import { useInView } from '../../lib/motion';

/**
 * #5 Contenedor que activa el revelado escalonado de sus hijos `.t-reveal`
 * (cada hijo puede llevar style={{'--i': n}} para el retraso en cascada).
 */
export default function Reveal({ as: Tag = 'div', className = '', children, ...rest }) {
  const [ref, inView] = useInView();
  return (
    <Tag ref={ref} className={`${className} ${inView ? 'is-inview' : ''}`} {...rest}>
      {children}
    </Tag>
  );
}
